import { create } from 'zustand';

type ReportViewMode = 'full' | 'split' | 'single';

type ReportViewModeStore = {
  viewMode: ReportViewMode;
  showShelfForSingleViewMode: boolean;
  setViewMode: (viewMode: ReportViewMode) => void;
  setShowShelfForSingleViewMode: (value: boolean) => void;
};

export const useReportViewModeStore = create<ReportViewModeStore>((set) => ({
  viewMode: 'full',
  showShelfForSingleViewMode: false,
  setViewMode: (viewMode) => set(() => ({ viewMode })),
  setShowShelfForSingleViewMode: (value) => set(() => ({ showShelfForSingleViewMode: value })),
}));
